module.exports = __webpack_public_path__ + "img/conversation.10a51766.png";